import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Stack, Typography } from "@mui/material";
import { createBrandTheme, Logo, colors } from "brand";

// Placeholder landing for announcer.foxvillage.com. Branded coming-soon splash —
// real React + MUI + brand app so the deploy scaffold is proven end to end.
// Respects the viewer's light/dark preference via the brand theme's colorSchemes.
const theme = createBrandTheme();

export default function App() {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
          textAlign: "center",
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box sx={{ color: colors.foxOrange, width: { xs: 240, sm: 360 } }}>
            <Logo style={{ width: "100%", height: "auto", display: "block" }} />
          </Box>
          <Typography variant="h3" sx={{ fontWeight: 700, color: "text.primary" }}>
            Announcer
          </Typography>
          <Typography variant="h6" sx={{ color: "text.secondary" }}>
            Coming soon
          </Typography>
        </Stack>
      </Box>
    </ThemeProvider>
  );
}
